class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === "plus") {
      if (
        parseInt(this.input.dataset.min) > parseInt(this.input.step) &&
        this.input.value == 0
      ) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (
      this.input.dataset.min === previousValue &&
      event.target.name === "minus"
    ) {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle(
        "disabled",
        parseInt(value) <= parseInt(this.input.min)
      );
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

const inputs = document.querySelectorAll(".quantity__input");

inputs.forEach(input => {
  input.addEventListener("input", () => {
    let val = parseInt(input.value, 10);
    const min = parseInt(input.dataset.min, 10);
    const max = parseInt(input.dataset.max, 10);

    if (isNaN(val)) val = min; // default to min if invalid
    if (val < min) val = min;
    if (val > max) val = max;
    input.value = val;
  });

  // optional: also validate on blur/change
  input.addEventListener("change", () => {
    let val = parseInt(input.value, 10);
    const min = parseInt(input.dataset.min, 10);
    const max = parseInt(input.dataset.max, 10);

    if (isNaN(val)) val = min;
    if (val < min) val = min;
    if (val > max) val = max;

    input.value = val;
  });
});

document.addEventListener("DOMContentLoaded", function () {
    function get_cart(){        
        
        jQuery.getJSON('/cart.js', function(cart) {
           console.log(cart);
           var html = '';
           var count = 0;
            for(var i=0; i<cart.items.length; i++){
              
              var item = cart.items[i];
             
              var forloop = i + 1; 
              
              if(item.product_title != 'Gift Box'){
                count += item.quantity; 
               html += '<div class="mmc_items">'+
                        '<div class="mmc_img">'+
                           '<a href="'+item.url+'" class="cart_page_image">'+
                              '<img src="'+item.image+'"/>'+
                            '</a>'+
                        '</div>'+
              '<div class="mmc_detail">'+
                '<div class="mmc_title"><a href="'+ item.url+'">'+item.title+'</a> </div>'+
                 
                '<div class="mmc_price" tabindex="0">'+Shopify.formatMoney(item.line_price)+' </div>'+
                
                 '<div class="mmc_qty" data-line-item-key='+forloop+'>'+
                   '<div aria-label="Cart quantity minus" class="mmc_sign mmc_min"><span class="icon "><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="minus"><rect x="5" y="46" width="90" height="8"/></g></svg></span></div>'+
                    '<input class="quantity-input" data-id="'+item.id+'"  type="text" name="quantity" value="'+item.quantity +'" data-line-id="'+ forloop +'">'+
                   '<div aria-label="Cart quantity plus" class="mmc_sign mmc_plus"><spna class="icon "><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="plus"><polygon points="95 46 54 46 54 5 46 5 46 46 5 46 5 54 46 54 46 95 54 95 54 54 95 54 95 46"/></g></svg></span></div>'+
                 '</div> '; 
                
                var  g_name = 'Gift Note for '+item.title;
                var gift = false , gift_txt = '',  class_active = '', style_show = '', name_att = '';
                    
                $(cart.attributes).each(function(index, attribute){
                   var name = 'Gift Note for '+item.title;
                   var first_title =  attribute[name];
                  
                  if(typeof first_title !== "undefined"){
                        var gift = true;
                        class_active = 'active';
                          style_show = 'style="display:block"';
                        gift_txt = attribute[name];
                        name_att = 'name="attributes['+name+']"';
                  }
                });
                         
            // get market type from body
              const marketType = document.body.dataset.marketType;

              // add giftwrap option only if NOT b2b-market
              if (marketType !== "b2b-market") {
                html +=  
                  '<div class="giftwrap-option" data-va="'+ gift+'"> '+
                    '<button class="giftwrap_btn '+class_active+'" data-qty="'+ item.quantity +'"  data-item-id="'+item.id+'" data-val="Gift Note for '+ item.title +'"   aria-label="Gift Box with Ribbon $6.00">'+
                      '<span class="giftwrap_check"></span>'+
                      '<span class="giftwrap_txt">Gift Box with Ribbon $6.00</span>'+
                    '</button>'+
                  '</div> '+
                  '<div class="gift-note-field" '+style_show+'> '+
                    '<label for="gift-note">Gift Note (Optional)</label> '+
                    '<textarea id="gift-note" '+name_att+' data-val="Gift Note for '+item.title+'" placeholder="Write gift note here.">'+ gift_txt +'</textarea> '+
                  '</div>';
              }

              // always add close button part
              html +=
                '</div>'+
                '<div class="mmc_close">'+
                  '<button data-item-id="'+item.id+'" class="close remove_item" tabindex="0" aria-label="Remove item" data-line="'+ forloop +'">'+
                    '<span class="icon ">'+
                      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">'+
                        '<g id="x">'+
                          '<polygon points="97.83 7.83 92.17 2.17 50 44.34 7.83 2.17 2.17 7.83 44.34 50 2.17 92.17 7.83 97.83 50 55.66 92.17 97.83 97.83 92.17 55.66 50 97.83 7.83"/>'+
                        '</g>'+
                      '</svg>'+
                    '</span>'+
                  '</button>'+
                '</div>'+
              '</div>';

              }
              
              $('.mmc_item_box').html(html);
              $('.mmc_total_price').html(Shopify.formatMoney(cart.total_price));
              
              $('.min_cart').addClass('active');
              $('.header-cart__count').html(count).css('display','flex');
              $('body').addClass('active_mincart');
               
            }
         });
        
      }
  const updateButton = document.querySelector("#update-cart-btn"); // your trigger button

  updateButton.addEventListener("click", function () {
    const inputs = document.querySelectorAll(".quantity__input");

    let updates = {};

    inputs.forEach((input) => {
      const variantId = input.getAttribute("data-quantity-variant-id");
      const quantity = parseInt(input.value, 10);

      // Only include if quantity is >= 0
      if (!isNaN(quantity)) {
        updates[variantId] = quantity;
      }
    });

    // Send update request to Shopify
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates }),
    })
      .then((response) => response.json())
      .then((cart) => {
        // Refresh the drawer content first
       get_cart();
        console.log("Cart updated:", cart);
      })
      .catch((error) => console.error("Error updating cart:", error));
  });

});
